{
  "id": "seeschstro-anlage1",
  "title": "Seeschifffahrtsstraßen-Ordnung, Anlage I (Sichtzeichen der Wasserstraßen)",
  "region": "A",
  "url": "https://www.gesetze-im-internet.de/seeschstro_1971/",
  "retrieved": "2026-09-19",
  "license": "Amtliches Werk, gemeinfrei (§ 5 UrhG)",
  "sections": {
    "B.1": {
      "id": "B.1",
      "heading": "Fährstelle",
      "paragraphs": [
        {
          "id": "a",
          "text": "für freifahrende Fähren"
        },
        {
          "id": "a.text1",
          "text": "eine rechteckige blaue Tafel mit weißem Symbol eines Fährschiffes;"
        },
        {
          "id": "b",
          "text": "für nicht freifahrende Fähren"
        },
        {
          "id": "b.text3",
          "text": "eine rechteckige blaue Tafel mit weißem Symbol eines Fährschiffes über einem waagerechten weißen Band."
        }
      ]
    },
    "B.2": {
      "id": "B.2",
      "heading": "Durchfahren von festen Brücken",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Öffnungen fester Brücken, deren Benutzung der Schiffahrt empfohlen wird:"
        },
        {
          "id": "a",
          "text": "in beiden Richtungen befahrbar"
        },
        {
          "id": "a.text2",
          "text": "eine quadratische, auf der Spitze stehende gelbe Tafel;"
        },
        {
          "id": "b",
          "text": "in einer Richtung befahrbar (Gegenverkehr gesperrt)"
        },
        {
          "id": "b.text4",
          "text": "zwei quadratische, auf der Spitze stehende gelbe Tafeln nebeneinander."
        }
      ]
    },
    "B.3": {
      "id": "B.3",
      "heading": "Fernsprechstelle",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "quadratische blaue Tafel mit weißem Symbol des Telefonhörers."
        }
      ]
    },
    "B.4": {
      "id": "B.4",
      "heading": "Grenzen eines Weichengebietes am Nord-Ostsee-Kanal",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(§ 2 Abs. 1 Nr. 18 Buchstabe c)"
        },
        {
          "id": "x.text1",
          "text": "quadratische weiße Tafel mit schwarzem Rand."
        },
        {
          "id": "x.text2",
          "text": "(Der Westteil der Weiche Audorf-Rade wird im Norden durch die Tonne 2/Oberreider 1 begrenzt.)"
        }
      ]
    },
    "B.5": {
      "id": "B.5",
      "heading": "Wasserski",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(§ 31 Abs. 1 Satz 1)"
        },
        {
          "id": "x.text1",
          "text": "Wasserflächen im Fahrwasser, auf denen Wasserskilaufen erlaubt ist:"
        },
        {
          "id": "x.text2",
          "text": "rechteckige blaue Tafel mit dem weißen Symbol eines Wasserskiläufers."
        }
      ]
    },
    "B.6": {
      "id": "B.6",
      "heading": "Außergewöhnliche Schiffahrtsbehinderung",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Bei Nacht:"
        },
        {
          "id": "x.text1",
          "text": "drei feste Lichter übereinander, die beiden oberen rot, das untere grün."
        },
        {
          "id": "x.text2",
          "text": "Am Tage:"
        },
        {
          "id": "x.text3",
          "text": "zwei schwarze Bälle übereinander und darunter ein schwarzer Kegel - Spitze unten."
        }
      ]
    },
    "B.7": {
      "id": "B.7",
      "heading": "Querströmung",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "mit gefährlichen Querströmungen ist zu rechnen:"
        },
        {
          "id": "x.text1",
          "text": "zwei feste weiße senkrecht nebeneinander stehende Lichtbalken."
        }
      ]
    },
    "B.8": {
      "id": "B.8",
      "heading": "Wassermotorräder",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(§ 31 Abs. 1 Satz 1)"
        },
        {
          "id": "x.text1",
          "text": "Wasserflächen im Fahrwasser, auf denen das Fahren mit Wassermotorrädern erlaubt ist:"
        },
        {
          "id": "x.text2",
          "text": "rechteckige blaue Tafel mit dem weißen Symbol eines Wassermotorrades."
        }
      ]
    },
    "B.9": {
      "id": "B.9",
      "heading": "Segelsurfbretter",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(§ 31 Abs. 1 Satz 1)"
        },
        {
          "id": "x.text1",
          "text": "Wasserflächen im Fahrwasser, auf denen das Fahren mit Segelsurfbrettern erlaubt ist:"
        },
        {
          "id": "x.text2",
          "text": "rechteckige blaue Tafel mit dem weißen Symbol eines Segelsurfers."
        }
      ]
    },
    "B.10": {
      "id": "B.10",
      "heading": "Kennzeichnung der Zufahrt zu Fahrwassern und der Mitte von Schiffahrtswegen",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Kennzeichnung der Zufahrt zu Fahrwassern von See aus sowie der Mitte von Schiffahrtswegen, sofern sie nicht durch Feuerschiffe, Großtonnen, Baken, Molen usw. erkennbar sind:"
        },
        {
          "id": "x.Farbe",
          "text": "rote und weiße senkrechte Streifen."
        },
        {
          "id": "x.Form",
          "text": "Kugeltonne, Leuchttonne, Spierentonne oder Stange (ggf. ohne Farbe)."
        },
        {
          "id": "x.Beschriftung",
          "text": "fortlaufende Beschriftung und/oder Nummern, ggf. mit dem (auch abgekürzten) Namen des Fahrwassers."
        },
        {
          "id": "x.Toppzeichen",
          "text": "roter Ball; Spierentonnen und Stangen sind immer mit Toppzeichen versehen."
        },
        {
          "id": "x.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "x.Feuer.Kennung",
          "text": "Iso/Glt. oder Oc/Ubr."
        }
      ]
    },
    "B.11": {
      "id": "B.11",
      "heading": "Bezeichnung der Fahrwasserseiten",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(Laterale Zeichen)"
        },
        {
          "id": "a",
          "text": "Steuerbordseite des Fahrwassers:"
        },
        {
          "id": "a.Farbe",
          "text": "grün."
        },
        {
          "id": "a.Form",
          "text": "Spitztonne, Leuchttonne oder Stange (ggf. ohne Farbe)."
        },
        {
          "id": "a.Beschriftung",
          "text": "fortlaufende ungerade Nummern - von See beginnend oder nach festgelegter Richtung - ggf. mit einem angehängten kleinen Buchstaben, ggf. in Verbindung mit dem (auch abgekürzten) Namen des Fahrwassers."
        },
        {
          "id": "a.Toppzeichen",
          "text": "grüner Kegel, Spitze oben, oder Besen abwärts; Stangen sind immer mit Toppzeichen versehen."
        },
        {
          "id": "a.Feuer.Farbe",
          "text": "grün."
        },
        {
          "id": "a.Feuer.Kennung",
          "text": "FL/Blz., Fl(2)/Blz.(2), Oc(2)/Ubr.(2), Oc(3)/Ubr.(3), Q/Fkl., IQ/Fkl. unt. oder Iso/Glt."
        },
        {
          "id": "b",
          "text": "Backbordseite des Fahrwassers"
        },
        {
          "id": "b.Farbe",
          "text": "rot."
        },
        {
          "id": "b.Form",
          "text": "Stumpftonne, Leuchttonne, Spierentonne, Stange (ggf. ohne Farbe) oder Pricke (ohne Farbe)."
        },
        {
          "id": "b.Beschriftung",
          "text": "fortlaufende gerade Nummern - von See beginnend oder nach festgelegter Richtung -, ggf. mit einem angehängten kleinen Buchstaben, ggf. in Verbindung mit dem (auch abgekürzten) Namen des Fahrwassers."
        },
        {
          "id": "b.Toppzeichen",
          "text": "roter Zylinder oder Besen aufwärts;"
        },
        {
          "id": "b.text13",
          "text": "Stangen sind immer mit Toppzeichen versehen."
        },
        {
          "id": "b.Feuer.Farbe",
          "text": "rot."
        },
        {
          "id": "b.Feuer.Kennung",
          "text": "Fl/Blz., Fl(2)/Blz.(2), Oc(2)/Ubr.(2), Oc(3)/Ubr.(3), Q/Fkl., IQ/Fkl. unt. oder Iso/Glt."
        }
      ]
    },
    "B.12": {
      "id": "B.12",
      "heading": "(aufgehoben)",
      "paragraphs": []
    },
    "B.13": {
      "id": "B.13",
      "heading": "Bezeichnung von abzweigenden oder einmündenden Fahrwassern",
      "paragraphs": [
        {
          "id": "a",
          "text": "Steuerbordseite des durchgehenden Fahrwassers/Backbordseite des abzweigenden oder einmündenden Fahrwassers:"
        },
        {
          "id": "a.Farbe",
          "text": "grün mit einem waagerechten roten Band."
        },
        {
          "id": "a.Form",
          "text": "Spitztonne, Leuchttonne oder Stange."
        },
        {
          "id": "a.Beschriftung",
          "text": "Unter der fortlaufenden ungeraden Nummer der Lateralbezeichnung des durchgehenden Fahrwassers, durch waagerechten Strich getrennt, der Name - ggf. abgekürzt - und die erste Nummer des abzweigenden oder die letzte Nummer des einmündenden Fahrwassers."
        },
        {
          "id": "a.Toppzeichen",
          "text": "grüner Kegel, Spitze oben oder Besen abwärts."
        },
        {
          "id": "a.Feuer.Farbe",
          "text": "grün."
        },
        {
          "id": "a.Feuer.Kennung",
          "text": "Fl(2+1)/Blz.(2+1)."
        },
        {
          "id": "b",
          "text": "Backbordseite des durchgehenden Fahrwassers/Steuerbordseite des abzweigenden oder einmündenden Fahrwassers:"
        },
        {
          "id": "b.Farbe",
          "text": "rot mit einem waagerechten grünen Band."
        },
        {
          "id": "b.Form",
          "text": "Stumpftonne, Leuchttonne, Spierentonne oder Stange."
        },
        {
          "id": "b.Beschriftung",
          "text": "Unter der fortlaufenden geraden Nummer der Lateralbezeichnung des durchgehenden Fahrwassers, durch waagerechten Strich getrennt, der Name - ggf. abgekürzt - und die erste Nummer des abzweigenden oder die letzte Nummer des einmündenden Fahrwassers."
        },
        {
          "id": "b.Toppzeichen",
          "text": "roter Zylinder oder Besen aufwärts."
        },
        {
          "id": "b.Feuer.Farbe",
          "text": "rot."
        },
        {
          "id": "b.Feuer.Kennung",
          "text": "Fl(2+1)/Blz.(2+1)."
        },
        {
          "id": "b.Feuer.text14",
          "text": "Die Positionen Steuerbordseite des durchgehenden Fahrwassers/Steuerbordseite des abzweigenden oder einmündenden Fahrwassers und Backbordseite des durchgehenden Fahrwassers/Backbordseite des abzweigenden oder einmündenden Fahrwassers können mit lateralen Zeichen (Zeichen B.11) bezeichnet werden. Sie erhalten dann eine Beschriftung wie vorstehend beschrieben, sowie ein Toppzeichen."
        },
        {
          "id": "b.Feuer.text15",
          "text": "Außerdem können abzweigende oder einmündende Fahrwasser mit kardinalen Zeichen (Zeichen B.15) und der vorstehenden Beschriftung bezeichnet werden."
        }
      ]
    },
    "B.14": {
      "id": "B.14",
      "heading": "Reeden",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "(§ 2 Abs. 1 Nr. 3)"
        },
        {
          "id": "a",
          "text": "Kennzeichnung allgemeiner Reeden:"
        },
        {
          "id": "a.Farbe",
          "text": "gelb."
        },
        {
          "id": "a.Form",
          "text": "Faßtonne oder Leuchttonne."
        },
        {
          "id": "a.Beschriftung",
          "text": "mit schwarzen Buchstaben ausgeschriebener oder abgekürzter Name der Reede und ggf. Nummer."
        },
        {
          "id": "a.Toppzeichen",
          "text": "gelbes liegendes Kreuz."
        },
        {
          "id": "a.Feuer.Farbe",
          "text": "gelb."
        },
        {
          "id": "a.Feuer.Kennung",
          "text": "Fl./Blz., Oc(2)/Ubr.(2) oder Oc(3)/Ubr.(3)."
        },
        {
          "id": "a.Feuer.text8",
          "text": "Grenzt die Reede an die Steuerbord- oder Backbordseite eines Fahrwassers, so ist diese Seite der Reede mit der entsprechenden Fahrwasserseitenbezeichnung gekennzeichnet (Zeichen B.11), die unter einem waagerechten Strich zusätzlich den ausgeschriebenen oder abgekürzten Namen der Reede und ggf. eine Nummer anzeigt."
        },
        {
          "id": "b",
          "text": "Kennzeichnung von Reeden für Fahrzeuge, die bestimmte gefährliche Güter befördern:"
        },
        {
          "id": "b.Farbe",
          "text": "gelb."
        },
        {
          "id": "b.Form",
          "text": "Faßtonne."
        },
        {
          "id": "b.Beschriftung",
          "text": "großes schwarzes \"P\", ggf. mit Nummer."
        },
        {
          "id": "b.Toppzeichen",
          "text": "gelbes liegendes Kreuz."
        },
        {
          "id": "c",
          "text": "Kennzeichnung von Reeden für unter Quarantäne stehende Fahrzeuge:"
        },
        {
          "id": "c.Farbe",
          "text": "gelb."
        },
        {
          "id": "c.Form",
          "text": "Faßtonne."
        },
        {
          "id": "c.Beschriftung",
          "text": "großes schwarzes \"Q\", ggf. mit Nummer."
        },
        {
          "id": "c.Toppzeichen",
          "text": "gelbes liegendes Kreuz"
        }
      ]
    },
    "B.15": {
      "id": "B.15",
      "heading": "Gefahrenstellen",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Allgemeine Gefahrenstellen (z.B. Untiefen, Wracks, Buhnen und sonstige Schiffahrtshindernisse)."
        },
        {
          "id": "x.text1",
          "text": "Eine allgemeine Gefahrenstelle ist in der Regel mit einem oder mehreren kardinalen Zeichen bezeichnet, die für die verschiedenen Quadranten den Bezug zur Lage der Gefahrenstelle angeben."
        },
        {
          "id": "a",
          "text": "Nord-Kardinal-Zeichen:"
        },
        {
          "id": "a.Farbe",
          "text": "schwarz über gelb."
        },
        {
          "id": "a.Form",
          "text": "Leuchttonne, Bakentonne, Spierentonne oder Stange."
        },
        {
          "id": "a.Beschriftung",
          "text": "Angabe des Bezugs, ggf. abgekürzt, und/oder Kompaßrichtung."
        },
        {
          "id": "a.Toppzeichen",
          "text": "zwei schwarze Kegel übereinander, Spitzen oben."
        },
        {
          "id": "a.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "a.Feuer.Kennung",
          "text": "VQ/SFkl. oder Q/Fkl."
        },
        {
          "id": "b",
          "text": "Ost-Kardinal-Zeichen:"
        },
        {
          "id": "b.Farbe",
          "text": "schwarz mit einem breiten waagerechten gelben Band."
        },
        {
          "id": "b.Form",
          "text": "Leuchttonne, Bakentonne, Spierentonne oder Stange."
        },
        {
          "id": "b.Beschriftung",
          "text": "Angabe des Bezuges, ggf. abgekürzt, und/oder Kompaßrichtung."
        },
        {
          "id": "b.Toppzeichen",
          "text": "zwei schwarze Kegel übereinander, Spitzen voneinander."
        },
        {
          "id": "b.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "b.Feuer.Kennung",
          "text": "VQ(3)/SFkl.(3) oder Q(3)/Fkl.(3)."
        },
        {
          "id": "c",
          "text": "Süd-Kardinal-Zeichen:"
        },
        {
          "id": "c.Farbe",
          "text": "gelb über schwarz."
        },
        {
          "id": "c.Form",
          "text": "Leuchttonne, Bakentonne, Spierentonne oder Stange."
        },
        {
          "id": "c.Beschriftung",
          "text": "Angabe des Bezuges, ggf. abgekürzt, und/oder Kompaßrichtung."
        },
        {
          "id": "c.Toppzeichen",
          "text": "zwei schwarze Kegel übereinander, Spitzen unten."
        },
        {
          "id": "c.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "c.Feuer.Kennung",
          "text": "VQ(6)+LFI/SFkl.(6)+Blk. oder VQ(6)+LFl/Fkl.(6)+Blk."
        },
        {
          "id": "d",
          "text": "West-Kardinal-Zeichen:"
        },
        {
          "id": "d.Farbe",
          "text": "gelb mit einem breiten waagerechten schwarzen Band."
        },
        {
          "id": "d.Form",
          "text": "Leuchttonne, Bakentonne, Spierentonne oder Stange."
        },
        {
          "id": "d.Beschriftung",
          "text": "Angabe des Bezuges, ggf. abgekürzt, und/oder Kompaßrichtung."
        },
        {
          "id": "d.Toppzeichen",
          "text": "zwei schwarze Kegel übereinander, Spitzen zueinander."
        },
        {
          "id": "d.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "d.Feuer.Kennung",
          "text": "VQ(9)/SFkl.(9) oder Q(9)/Fkl.(9)."
        },
        {
          "id": "e",
          "text": "Einzelgefahrenstelle"
        },
        {
          "id": "e.text31",
          "text": "Die Gefahrenstelle kann an allen Seiten passiert werden."
        },
        {
          "id": "e.Farbe",
          "text": "schwarz mit einem breiten waagerechten roten Band."
        },
        {
          "id": "e.Form",
          "text": "Leuchttonne, Bakentonne, Spierentonne oder Stange."
        },
        {
          "id": "e.Beschriftung",
          "text": "Name der Gefahrenstelle."
        },
        {
          "id": "e.Toppzeichen",
          "text": "zwei schwarze Bälle übereinander."
        },
        {
          "id": "e.Feuer.Farbe",
          "text": "weiß."
        },
        {
          "id": "e.Feuer.Kennung",
          "text": "Fl(2)/Blz.(2)."
        },
        {
          "id": "f",
          "text": "Neue Gefahrenstellen"
        },
        {
          "id": "f.text39",
          "text": "Bezeichnung wie allgemeine Gefahrenstellen oder Einzelgefahrenstellen, jedoch wegen besonderer Umstände mindestens ein Sichtzeichen doppelt und ggf. mit einer Radarantwortbake mit der Kennung \"D\" versehen."
        }
      ]
    },
    "B.16": {
      "id": "B.16",
      "heading": "Kennzeichnung besonderer Gebiete und Stellen",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Die Bedeutung ist den Seekarten oder anderen nautischen Veröffentlichungen zu entnehmen und ggf. auch aus der Beschriftung des Zeichens zu erkennen."
        },
        {
          "id": "x.Farbe",
          "text": "gelb."
        },
        {
          "id": "x.Form",
          "text": "beliebig, vorzugsweise Faßtonne, Leuchttonne, Spierentonne oder Stange."
        },
        {
          "id": "x.Beschriftung",
          "text": "jeweilige Bedeutung in schwarzen Buchstaben."
        },
        {
          "id": "x.Toppzeichen",
          "text": "gelbes liegendes Kreuz."
        },
        {
          "id": "x.Feuer.Farbe",
          "text": "gelb."
        },
        {
          "id": "x.Feuer.Kennung",
          "text": "Fl/Blz., Oc(2)/Ubr.(2) oder Oc(3)/Ubr.(3), bei dem Beispiel g) nur Fl(5)/Blz.(5)."
        },
        {
          "id": "x.Feuer.text7",
          "text": "Beispiele für Beschriftung:"
        },
        {
          "id": "a",
          "text": "Warngebiet"
        },
        {
          "id": "a.text9",
          "text": "Grenze eines Gebietes, vor dessen Befahren, z.B. wegen militärischer Übungen oder wegen Forschungs- und Vermessungsarbeiten, hydrographischer Untersuchungen und ähnliche Arbeiten, gewarnt wird."
        },
        {
          "id": "a.Beschriftung",
          "text": "\"Warngebiet\" oder \"Warn.-G\"."
        },
        {
          "id": "a.text11",
          "text": "Wenn das Warngebiet durch das Zeigen auf Grund besonderer Rechtsvorschriften eingeführter Sichtzeichen vorübergehend zum Sperrgebiet werden kann, tragen die Faßtonnen, Leuchttonnen, Spierentonnen oder Stangen ein"
        },
        {
          "id": "a.Toppzeichen",
          "text": "gelbes liegendes Kreuz."
        },
        {
          "id": "b",
          "text": "Warnstelle"
        },
        {
          "id": "b.text14",
          "text": "Stelle (z.B. für militärische Zwecke und für Forschungs- und Vermessungsarbeiten, hydrographische und ozeanographische Untersuchungen und ähnliche Arbeiten sowie die dazugehörigen Geräte), vor deren Annäherung oder Überfahren gewarnt wird."
        },
        {
          "id": "b.Beschriftung",
          "text": "\"Warnstelle\" oder \"Warn-St.\"."
        },
        {
          "id": "c",
          "text": "Fischereigründe"
        },
        {
          "id": "c.text17",
          "text": "Begrenzung von Fischereigründen, Schongebieten und Muschelkulturen sowie ggf. der Zufahrten zu ihnen."
        },
        {
          "id": "c.Beschriftung",
          "text": "\"Fischerei\" oder \"Fisch\"."
        },
        {
          "id": "c.Toppzeichen",
          "text": "gelber Körper in Form eines Fisches."
        },
        {
          "id": "d",
          "text": "Baggerschüttstelle"
        },
        {
          "id": "d.text21",
          "text": "Begrenzung eines Gebietes, in dem Baggergut verklappt wird."
        },
        {
          "id": "d.Beschriftung",
          "text": "\"Schüttstelle\" oder \"Schütt-St.\"."
        },
        {
          "id": "e",
          "text": "Kabel und Rohrleitungen"
        },
        {
          "id": "e.text24",
          "text": "Kennzeichnung von Trassen, Kabeln und Rohrleitungen."
        },
        {
          "id": "e.Beschriftung",
          "text": "\"Kabel\", \"K\", \"Pipeline\" oder \"Pipe\"."
        },
        {
          "id": "f",
          "text": "Gemessene Meile"
        },
        {
          "id": "f.text27",
          "text": "Zeichen, die eine gemessene Meile bezeichnen;"
        },
        {
          "id": "f.Beschriftung",
          "text": "\"Meile\"."
        },
        {
          "id": "g",
          "text": "Ozeanographische Meßstationen (ODAS)"
        },
        {
          "id": "g.text30",
          "text": "Kennzeichnung schwimmender Einrichtungen, mit denen ozeanographische Daten gemessen werden;"
        },
        {
          "id": "g.Beschriftung",
          "text": "\"ODAS\"."
        },
        {
          "id": "g.text32",
          "text": "Kennzeichnung:"
        },
        {
          "id": "g.text33",
          "text": "Fl(5)/Blz.(5)."
        }
      ]
    },
    "B.17": {
      "id": "B.17",
      "heading": "Festmachetonne",
      "paragraphs": [
        {
          "id": "x.text0",
          "text": "Tonne, an der festgemacht werden darf."
        },
        {
          "id": "x.Farbe",
          "text": "gelb."
        },
        {
          "id": "x.Form",
          "text": "Faßtonne, Zylindertonne oder Tonne in beliebiger Form."
        },
        {
          "id": "x.Beschriftung",
          "text": "mit schwarzen Buchstaben \"Festmachen\" oder \"Festm.\"."
        },
        {
          "id": "x.text4",
          "text": "Abschnitt II - Schallsignale"
        },
        {
          "id": "x.text5",
          "text": "C.1"
        },
        {
          "id": "x.text6",
          "text": "Anhalten"
        },
        {
          "id": "x.text7",
          "text": "von einem Fahrzeug des öffentlichen Dienstes:"
        },
        {
          "id": "x.text8",
          "text": "ein kurzer Ton, ein langer Ton, zwei kurze Töne."
        },
        {
          "id": "x.text9",
          "text": "C.2"
        },
        {
          "id": "x.text10",
          "text": "Durchfahren/Einfahren verboten"
        },
        {
          "id": "x.text11",
          "text": "(Brücke, Sperrwerk, Schleuse kann vorübergehend nicht geöffnet werden)"
        },
        {
          "id": "x.text12",
          "text": "vier kurze Töne."
        },
        {
          "id": "x.text13",
          "text": "C.3"
        },
        {
          "id": "x.text14",
          "text": "Durchfahren/Einfahren"
        },
        {
          "id": "x.text15",
          "text": "(Brücke/Sperrwerk/Schleuse geöffnet, Hubbrücken dürfen jedoch nur von Fahrzeugen durchfahren werden, für die die Durchfahrtshöhe der letzten Hubstufe mit Sicherheit ausreicht.)"
        },
        {
          "id": "a",
          "text": "für seewärts fahrende Fahrzeuge"
        },
        {
          "id": "a.text17",
          "text": "zwei lange Töne, ein kurzer Ton, ein langer Ton."
        },
        {
          "id": "b",
          "text": "für binnenwärts fahrende Fahrzeuge"
        },
        {
          "id": "b.text19",
          "text": "zwei lange Töne, zwei kurze Töne, ein langer Ton."
        },
        {
          "id": "b.text20",
          "text": "C.4"
        },
        {
          "id": "b.text21",
          "text": "Sperrung der Seeschiffahrtsstraße"
        },
        {
          "id": "b.text22",
          "text": "zwei Gruppen von drei langen Tönen."
        },
        {
          "id": "b.text23",
          "text": "C.5"
        },
        {
          "id": "b.text24",
          "text": "Einfahren in die Zufahrten und Schleusen des Nord-Ostsee-Kanals von See"
        },
        {
          "id": "a",
          "text": "Brunsbüttel (Neue Schleuse):"
        },
        {
          "id": "a.text26",
          "text": "ein nach jeweils 7 Sekunden wiederkehrender Ton von 3 Sekunden Dauer."
        },
        {
          "id": "b",
          "text": "Kiel-Holtenau (Neue Schleuse)"
        },
        {
          "id": "b.text28",
          "text": "in die rechte Schleusenkammer:"
        },
        {
          "id": "b.text29",
          "text": "ein nach jeweils 7 Sekunden wiederkehrender Ton von 3 Sekunden Dauer."
        },
        {
          "id": "b.text30",
          "text": "in die linke Schleusenkammer:"
        },
        {
          "id": "b.text31",
          "text": "eine nach jeweils 5 Sekunden wiederkehrende Gruppe von zwei Tönen von je zwei Sekunden Dauer mit einer Unterbrechung von 1 Sekunde."
        },
        {
          "id": "b.text32",
          "text": "C.6"
        },
        {
          "id": "b.text33",
          "text": "Einfahren in die Schleusen des Nord-Ostsee-Kanals vom Kanal aus"
        },
        {
          "id": "a",
          "text": "Brunsbüttel (Neue Schleuse)"
        },
        {
          "id": "a.text35",
          "text": "in die rechte Schleusenkammer:"
        },
        {
          "id": "a.text36",
          "text": "dauernde Einzelschläge der Glocke."
        },
        {
          "id": "a.text37",
          "text": "in die linke Schleusenkammer:"
        },
        {
          "id": "a.text38",
          "text": "Doppelschläge der Glocke in Zwischenräumen von 4 Sekunden."
        },
        {
          "id": "b",
          "text": "Kiel-Holtenau (Neue Schleuse)"
        },
        {
          "id": "b.text40",
          "text": "in die rechte Schleusenkammer:"
        },
        {
          "id": "b.text41",
          "text": "Einzelschläge der Glocke alle 3 Sekunden."
        },
        {
          "id": "b.text42",
          "text": "in die linke Schleusenkammer:"
        },
        {
          "id": "b.text43",
          "text": "Doppelschläge der Glocke alle 3 Sekunden."
        },
        {
          "id": "b.text44",
          "text": "SeeSchStrO 1971 SeeSchStrO Anlage II Sichtzeichen und Schallsignale der Fahrzeuge"
        },
        {
          "id": "b.text45",
          "text": "Fundstelle des Originaltextes: BGBl. I 1998, 3252 - 3262; bzgl. der einzelnen Änderungen vgl. Fußnote"
        },
        {
          "id": "b.text46",
          "text": "II.1 Sichtzeichen II.2 Schallsignale Erläuterung zur Anlage II"
        },
        {
          "id": "b.text47",
          "text": "1."
        },
        {
          "id": "b.text48",
          "text": "Allgemeines"
        },
        {
          "id": "b.text49",
          "text": "Gemäß § 6 Abs. 1 haben Fahrzeuge zusätzlich zu den in den Kollisionsverhütungsregeln vorgeschriebenen Sichtzeichen und Schallsignalen nur solche nach Maßgabe dieser Anlage zu führen, zu zeigen oder zu geben."
        },
        {
          "id": "b.text50",
          "text": "2."
        },
        {
          "id": "b.text51",
          "text": "Zu den Lichtern"
        },
        {
          "id": "b.text52",
          "text": "Die nach den Kollisionsverhütungsregeln vorgeschriebenen Lichter sind zusätzlich dargestellt."
        },
        {
          "id": "b.text53",
          "text": "2.1"
        },
        {
          "id": "b.text54",
          "text": "Kennzeichnung der Lichter"
        },
        {
          "id": "b.text55",
          "text": "Ist ein Funkellicht vorgeschrieben, so ist als Zeitmaß mindestens 120 Lichterscheinungen in der Minute einzuhalten."
        },
        {
          "id": "b.text56",
          "text": "2.2"
        },
        {
          "id": "b.text57",
          "text": "Darstellung der Lichter"
        },
        {
          "id": "b.text58",
          "text": "Rundumlicht in der angegebenen Farbe,"
        },
        {
          "id": "b.text59",
          "text": "festes Licht in der angegebenen Farbe, sichtbar über einen begrenzten Horizontbogen,"
        },
        {
          "id": "b.text60",
          "text": "festes Licht in der angegebenen Farbe, sichtbar über einen begrenzten Horizontbogen, vom Beobachter abgekehrte Richtung,"
        },
        {
          "id": "b.text61",
          "text": "Funkellicht in der angegebenen Farbe, sichtbar über den ganzen Horizont,"
        },
        {
          "id": "b.text62",
          "text": "Gleichtaktlicht in der angegebenen Farbe, sichtbar über den ganzen Horizont,"
        },
        {
          "id": "b.text63",
          "text": "auf und nieder bewegtes Licht in der angegebenen Farbe, sichtbar über den ganzen Horizont,"
        },
        {
          "id": "b.text64",
          "text": "Leuchtkugel mit Sternen in der angegebenen Farbe."
        },
        {
          "id": "b.text65",
          "text": "3."
        },
        {
          "id": "b.text66",
          "text": "Zu den Schallsignalen"
        },
        {
          "id": "b.text67",
          "text": "Darstellung der Schallsignale"
        },
        {
          "id": "b.text68",
          "text": "1 langer Ton"
        },
        {
          "id": "b.text69",
          "text": "1 kurzer Ton ... (Abb."
        },
        {
          "id": "b.text70",
          "text": "Glockenschlag"
        },
        {
          "id": "b.text71",
          "text": "rasches Läuten der Glocke."
        },
        {
          "id": "b.text72",
          "text": "II.1 Sichtzeichen der Fahrzeuge"
        },
        {
          "id": "b.text73",
          "text": "1."
        },
        {
          "id": "b.text74",
          "text": "Fahrzeuge des öffentlichen Dienstes bei Erfüllung polizeilicher Aufgaben"
        },
        {
          "id": "b.text75",
          "text": "(§ 7)"
        },
        {
          "id": "b.text76",
          "text": "Fahrzeuge des öffentlichen Dienstes haben bei der Erfüllung polizeilicher Aufgaben, wenn dadurch die Sicherheit und Leichtigkeit des Verkehrs gefährdet wird, zu zeigen:"
        },
        {
          "id": "b.text77",
          "text": "ein dauerndes blaues Funkellicht."
        },
        {
          "id": "b.text78",
          "text": "Gleiches gilt für Fahrzeuge der Deutschen Gesellschaft zur Rettung Schiffbrüchiger bei der Durchführung eines Rettungseinsatzes."
        },
        {
          "id": "b.text79",
          "text": "2."
        },
        {
          "id": "b.text80",
          "text": "Zollfahrzeuge"
        },
        {
          "id": "b.text81",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text82",
          "text": "drei grüne Rundumlichter senkrecht übereinander."
        },
        {
          "id": "b.text83",
          "text": "Am Tage:"
        },
        {
          "id": "b.text84",
          "text": "eine viereckige grüne Flagge an beliebiger Stelle."
        },
        {
          "id": "b.text85",
          "text": "3."
        },
        {
          "id": "b.text86",
          "text": "Fahrzeuge der Bundeswehr und der Bundespolizei sowie Maschinenfahrzeuge, die Schießscheiben schleppen"
        },
        {
          "id": "b.text87",
          "text": "Fahrzeuge der Bundeswehr und der Bundespolizei sowie Maschinenfahrzeuge, die Schießscheiben schleppen, denen sich bei Nacht Fahrzeuge in Gefahr drohender Weise nähern und von denen ein ausreichender Abstand zu halten ist:"
        },
        {
          "id": "b.text88",
          "text": "Leuchtkugeln mit weißen Sternen."
        },
        {
          "id": "b.text89",
          "text": "4."
        },
        {
          "id": "b.text90",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text91",
          "text": "5."
        },
        {
          "id": "b.text92",
          "text": "Fähren"
        },
        {
          "id": "b.text93",
          "text": "(§ 2 Abs. 1 Nr. 12)"
        },
        {
          "id": "b.text94",
          "text": "5.1"
        },
        {
          "id": "b.text95",
          "text": "Nicht freifahrende Fähren in Fahrt"
        },
        {
          "id": "b.text96",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text97",
          "text": "ein grünes Rundumlicht über einem weißen Rundumlicht."
        },
        {
          "id": "b.text98",
          "text": "5.2"
        },
        {
          "id": "b.text99",
          "text": "Freifahrende Fähren auf dem Nord-Ostsee-Kanal, der Trave und der Warnow in Fahrt"
        },
        {
          "id": "b.text100",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text101",
          "text": "je ein gelbes Gleichtaktlicht im Topp sowie vorn und hinten an jeder Seite (bei den Ecklichtern nur sichtbar im fahrzeugabgewandten Sichtwinkel)."
        },
        {
          "id": "b.text102",
          "text": "6."
        },
        {
          "id": "b.text103",
          "text": "Fahrzeuge und Schub- und Schleppverbände, die bestimmte gefährliche Güter befördern (§ 2 Abs. 1 Nr. 16) und leere Fahrzeuge im Sinne des § 30 Abs. 1 Nr. 3 sowie auf dem Nord-Ostsee-Kanal die bekannt gemachten besonders gefährlichen Fahrzeuge, Schub- und Schleppverbände"
        },
        {
          "id": "b.text104",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text105",
          "text": "ein rotes Rundumlicht."
        },
        {
          "id": "b.text106",
          "text": "Am Tage:"
        },
        {
          "id": "b.text107",
          "text": "die Flagge \"B\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text108",
          "text": "Auf dem Nord-Ostsee-Kanal müssen diese Sichtzeichen an der Backbord-Rah oder an anderer geeigneter, von vorn gut sichtbarer Stelle der Backbordseite geführt werden."
        },
        {
          "id": "b.text109",
          "text": "Diese Sichtzeichen sind auch zu führen, wenn die Fahrzeuge ankern oder festgemacht haben."
        },
        {
          "id": "b.text110",
          "text": "Von dieser Regelung sind Kriegsfahrzeuge ausgenommen."
        },
        {
          "id": "b.text111",
          "text": "7."
        },
        {
          "id": "b.text112",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text113",
          "text": "8."
        },
        {
          "id": "b.text114",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text115",
          "text": "9"
        },
        {
          "id": "b.text116",
          "text": "Schwimmendes Zubehör, das von Fahrzeugen, die baggern oder Unterwasserarbeiten ausführen, bei ihrem Einsatz verwendet wird"
        },
        {
          "id": "b.text117",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text118",
          "text": "ein weißes Rundumlicht."
        },
        {
          "id": "b.text119",
          "text": "Am Tage:"
        },
        {
          "id": "b.text120",
          "text": "eine viereckige rote Tafel."
        },
        {
          "id": "b.text121",
          "text": "10."
        },
        {
          "id": "b.text122",
          "text": "Manövrierbehinderte Fahrzeuge, die im Fahrwasser baggern oder Unterwasserarbeiten ausführen"
        },
        {
          "id": "b.text123",
          "text": "Manövrierbehinderte Fahrzeuge, die im Fahrwasser baggern oder Unterwasserarbeiten ausführen, haben, wenn an keiner Seite eine Behinderung besteht, zusätzlich zu der Bezeichnung nach Regel 27 Buchstabe b der Kollisionsverhütungsregeln an jeder Seite zu führen:"
        },
        {
          "id": "b.text124",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text125",
          "text": "zwei grüne Rundumlichter senkrecht übereinander."
        },
        {
          "id": "b.text126",
          "text": "Am Tage:"
        },
        {
          "id": "b.text127",
          "text": "zwei Rhomben senkrecht übereinander."
        },
        {
          "id": "b.text128",
          "text": "11."
        },
        {
          "id": "b.text129",
          "text": "Festgemachte Fahrzeuge, schwimmende Anlagen (§ 2 Abs. 1 Nr. 5) und außergewöhnliche Schwimmkörper (§ 2 Abs. 1 Nr. 6)"
        },
        {
          "id": "b.text130",
          "text": "11.1"
        },
        {
          "id": "b.text131",
          "text": "Bei einer Fahrzeuglänge von weniger als 50 m"
        },
        {
          "id": "b.text132",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text133",
          "text": "ein weißes Rundumlicht mittschiffs an der Fahrwasserseite oder an dem am weitesten zum Fahrwasser reichenden Ende, möglichst in Deckshöhe."
        },
        {
          "id": "b.text134",
          "text": "11.2"
        },
        {
          "id": "b.text135",
          "text": "Bei einer Fahrzeuglänge von 50 m und mehr"
        },
        {
          "id": "b.text136",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text137",
          "text": "je ein weißes Rundumlicht vorn und hinten an der Fahrwasserseite, möglichst in Deckshöhe."
        },
        {
          "id": "b.text138",
          "text": "11.3"
        },
        {
          "id": "b.text139",
          "text": "Ausnahmen und Sonderregelungen"
        },
        {
          "id": "b.text140",
          "text": "Festgemachte Fahrzeuge brauchen, ausgenommen auf dem Nord-Ostsee-Kanal, keine Sichtzeichen zu führen, wenn die Umrisse des Fahrzeugs durch andere Lichtquellen ausreichend und dauernd erkennbar sind oder das Fahrzeug im Bereich einer Liegestelle liegt, deren Umrisse ausreichend und dauernd erkennbar sind."
        },
        {
          "id": "b.text141",
          "text": "Dies gilt auch für schwimmende Anlagen und außergewöhnliche Schwimmkörper. Auf dem Nord-Ostsee-Kanal brauchen Sportfahrzeuge an den dafür bestimmten Liegestellen keine Lichter zu führen."
        },
        {
          "id": "b.text142",
          "text": "Sind zwei oder mehrere Fahrzeuge nebeneinander festgemacht, so braucht nur das dem Fahrwasser am nächsten liegende Fahrzeug das Sichtzeichen zu führen. Dies gilt auch für außergewöhnliche Schwimmkörper."
        },
        {
          "id": "b.text143",
          "text": "Fahrzeuge auf dem Nord-Ostsee-Kanal, die in den Weichengebieten aus anderen als verkehrs- oder wetterbedingten Gründen liegen, haben das Sichtzeichen zu zeigen; bei einem Schleppverband hat jedes Fahrzeug die Sichtzeichen zu führen."
        },
        {
          "id": "b.text144",
          "text": "11.4"
        },
        {
          "id": "b.text145",
          "text": "Fahrzeuge, die an einer Festmachetonne B.17 der Anlage I liegen"
        },
        {
          "id": "b.text146",
          "text": "Diese Fahrzeuge haben das Sichtzeichen für Ankerlieger nach Regel 30 der Kollisionsverhütungsregeln zu führen."
        },
        {
          "id": "b.text147",
          "text": "12."
        },
        {
          "id": "b.text148",
          "text": "Fahrzeuge mit Seelotsen auf dem Nord-Ostsee-Kanal (§ 2 Abs. 1 Nr. 18a) vor dem Auslaufen aus der Schleuse zum Kanal"
        },
        {
          "id": "b.text149",
          "text": "Die Sichtzeichen sind vor dem Auslaufen aus der Schleuse zum Kanal zu setzen."
        },
        {
          "id": "b.text150",
          "text": "12.1"
        },
        {
          "id": "b.text151",
          "text": "Verkehrsgruppen 1 und 2"
        },
        {
          "id": "b.text152",
          "text": "Am Tage:"
        },
        {
          "id": "b.text153",
          "text": "die Flagge \"H\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text154",
          "text": "12.2"
        },
        {
          "id": "b.text155",
          "text": "Verkehrsgruppe 3"
        },
        {
          "id": "b.text156",
          "text": "keine besondere Kennzeichnung."
        },
        {
          "id": "b.text157",
          "text": "12.3"
        },
        {
          "id": "b.text158",
          "text": "Verkehrsgruppe 4"
        },
        {
          "id": "b.text159",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text160",
          "text": "ein grünes Rundumlicht."
        },
        {
          "id": "b.text161",
          "text": "Am Tage:"
        },
        {
          "id": "b.text162",
          "text": "ein schwarzer Zylinder."
        },
        {
          "id": "b.text163",
          "text": "12.4"
        },
        {
          "id": "b.text164",
          "text": "Verkehrsgruppen 5 und 6"
        },
        {
          "id": "b.text165",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text166",
          "text": "zwei grüne Rundumlichter senkrecht übereinander."
        },
        {
          "id": "b.text167",
          "text": "Am Tage:"
        },
        {
          "id": "b.text168",
          "text": "ein schwarzer Zylinder, darunter ein schwarzer Ball."
        },
        {
          "id": "b.text169",
          "text": "Die Sichtzeichen der Verkehrsgruppen 4 bis 6 müssen an der Steuerbord-Rah oder an anderer geeigneter, von vorn gut sichtbarer Stelle der Steuerbordseite geführt werden."
        },
        {
          "id": "b.text170",
          "text": "13."
        },
        {
          "id": "b.text171",
          "text": "Freifahrer auf dem Nord-Ostsee-Kanal (§ 2 Abs. 1 Nr. 15) einschließlich des Einlaufens in die Schleusen"
        },
        {
          "id": "b.text172",
          "text": "Die Sichtanzeigen sind vor dem Einlaufen in die Schleusen zum Kanal zu setzen."
        },
        {
          "id": "b.text173",
          "text": "13.1"
        },
        {
          "id": "b.text174",
          "text": "Verkehrsgruppe 1"
        },
        {
          "id": "b.text175",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text176",
          "text": "ein gelbes Rundumlicht mindestens 1,50 m senkrecht unterhalb des vorderen Topplichtes."
        },
        {
          "id": "b.text177",
          "text": "Am Tage:"
        },
        {
          "id": "b.text178",
          "text": "die Flagge \"N\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text179",
          "text": "13.2"
        },
        {
          "id": "b.text180",
          "text": "Verkehrsgruppe 2"
        },
        {
          "id": "b.text181",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text182",
          "text": "ein gelbes Rundumlicht mindestens 1,50 m senkrecht unterhalb des vorderen Topplichtes."
        },
        {
          "id": "b.text183",
          "text": "Am Tage:"
        },
        {
          "id": "b.text184",
          "text": "die Flagge \"N\" und darunter den Zahlenwimpel \"2\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text185",
          "text": "13.3"
        },
        {
          "id": "b.text186",
          "text": "Verkehrsgruppe 3"
        },
        {
          "id": "b.text187",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text188",
          "text": "ein gelbes Rundumlicht mindestens 1,50 m senkrecht unterhalb des vorderen Topplichtes."
        },
        {
          "id": "b.text189",
          "text": "Am Tage:"
        },
        {
          "id": "b.text190",
          "text": "die Flagge \"N\" und darunter den Zahlenwimpel \"3\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text191",
          "text": "13.4"
        },
        {
          "id": "b.text192",
          "text": "Verkehrsgruppe 4"
        },
        {
          "id": "b.text193",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text194",
          "text": "ein gelbes Rundumlicht mindestens 1,50 m senkrecht unterhalb des vorderen Topplichtes, ein grünes Rundumlicht."
        },
        {
          "id": "b.text195",
          "text": "Am Tage:"
        },
        {
          "id": "b.text196",
          "text": "die Flagge \"N\" und darunter den Zahlenwimpel \"4\" des Internationalen Signalbuches, ein schwarzer Zylinder."
        },
        {
          "id": "b.text197",
          "text": "Die Sichtzeichen der Verkehrsgruppe 4 müssen an der Steuerbord-Rah oder an anderer geeigneter, von vorn gut sichtbarer Stelle der Steuerbordseite geführt werden."
        },
        {
          "id": "b.text198",
          "text": "14."
        },
        {
          "id": "b.text199",
          "text": "Am Ufer festgekommene Fahrzeuge auf dem Nord-Ostsee-Kanal an der Seite, an der vorbeigefahren werden darf"
        },
        {
          "id": "b.text200",
          "text": "Bei Nacht:"
        },
        {
          "id": "b.text201",
          "text": "ein weißes Rundumlicht an dem am weitesten ins Fahrwasser reichenden Fahrzeugteil."
        },
        {
          "id": "b.text202",
          "text": "15."
        },
        {
          "id": "b.text203",
          "text": "Fahrzeuge, die einen Seelotsen anfordern"
        },
        {
          "id": "b.text204",
          "text": "15.1"
        },
        {
          "id": "b.text205",
          "text": "Bei den Außenstationen der Seelotsenreviere für die Revierfahrten, auf der Reede vor Bremerhaven für die Fahrt nach der Außenstation des Lotsenfahrzeugs oder nach den stadtbremischen Häfen in Bremen oder auf der Reede vor Brunsbüttel für die Fahrt nach der Außenstation des Lotsenfahrzeugs oder nach Hamburg"
        },
        {
          "id": "b.text206",
          "text": "Am Tage:"
        },
        {
          "id": "b.text207",
          "text": "die Flagge \"G\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text208",
          "text": "15.2"
        },
        {
          "id": "b.text209",
          "text": "Bei der Station des Lotsenfahrzeugs in der Jade/Weser- Ansteuerung für die Fahrt nach Wilhelmshaven, auf der Reede vor Bremerhaven für die Fahrt nach einem niedersächsischen Hafen im Wesergebiet oder auf den Reeden vor Brunsbüttel und Kiel-Holtenau für die Fahrtstrecken des Nord-Ostsee-Kanals"
        },
        {
          "id": "b.text210",
          "text": "Am Tage:"
        },
        {
          "id": "b.text211",
          "text": "die Flagge \"G\" des Internationalen Signalbuches und der darunter gesetzte Wimpel 1."
        },
        {
          "id": "b.text212",
          "text": "16."
        },
        {
          "id": "b.text213",
          "text": "Fahrzeuge, die einen Seelotsen absetzen wollen"
        },
        {
          "id": "b.text214",
          "text": "Am Tage:"
        },
        {
          "id": "b.text215",
          "text": "die halbgehißte Flagge \"G\" des Internationalen Signalbuches."
        },
        {
          "id": "b.text216",
          "text": "II.2 Schallsignale der Fahrzeuge"
        },
        {
          "id": "b.text217",
          "text": "1."
        },
        {
          "id": "b.text218",
          "text": "Achtungssignal"
        },
        {
          "id": "b.text219",
          "text": "Das Schallsignal ist in allen Fällen zu geben, in denen die Verkehrslage ein Achtungssignal erfordert, insbesondere"
        },
        {
          "id": "b.text220",
          "text": "beim Einlaufen in andere Fahrwasser und Häfen, beim Auslaufen aus ihnen sowie aus Schleusen und beim Verlassen von Liege- und Ankerplätzen und"
        },
        {
          "id": "b.text221",
          "text": "auf dem Nord-Ostsee-Kanal bei der Annäherung an schwimmende Geräte und an Stellen, die durch ein Sichtzeichen A.4 (Anlage I) gekennzeichnet sind, sowie beim Ablegen von der Bunkerstation Projensdorf, wenn das Fahrzeug westwärts fahren will."
        },
        {
          "id": "b.text222",
          "text": "Ein Maschinenfahrzeug, das Schießscheiben schleppt, hat das Schallsignal zu geben, wenn sich bei Nacht ein Fahrzeug in Gefahr drohender Weise nähert."
        },
        {
          "id": "b.text223",
          "text": "1.1"
        },
        {
          "id": "b.text224",
          "text": "Auf allen Seeschiffahrtsstraßen mit Ausnahme auf dem Nord-Ostsee-Kanal:"
        },
        {
          "id": "b.text225",
          "text": "ein langer Ton."
        },
        {
          "id": "b.text226",
          "text": "1.2"
        },
        {
          "id": "b.text227",
          "text": "Auf dem Nord-Ostsee-Kanal:"
        },
        {
          "id": "b.text228",
          "text": "1.2.1"
        },
        {
          "id": "b.text229",
          "text": "Westwärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text230",
          "text": "ein langer Ton."
        },
        {
          "id": "b.text231",
          "text": "1.2.2"
        },
        {
          "id": "b.text232",
          "text": "Ostwärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text233",
          "text": "zwei lange Töne."
        },
        {
          "id": "b.text234",
          "text": "2."
        },
        {
          "id": "b.text235",
          "text": "Gefahr- und Warnsignal"
        },
        {
          "id": "b.text236",
          "text": "2.1"
        },
        {
          "id": "b.text237",
          "text": "Allgemeines Gefahr- und Warnsignal"
        },
        {
          "id": "b.text238",
          "text": "Gefährdet ein Fahrzeug ein anderes Fahrzeug oder wird es durch dieses selbst gefährdet, hat es soweit möglich rechtzeitig das Schallsignal zu geben:"
        },
        {
          "id": "b.text239",
          "text": "ein langer Ton, vier kurze Töne,"
        },
        {
          "id": "b.text240",
          "text": "ein langer Ton, vier kurze Töne."
        },
        {
          "id": "b.text241",
          "text": "2.2"
        },
        {
          "id": "b.text242",
          "text": "Bleib-weg-Signal"
        },
        {
          "id": "b.text243",
          "text": "Werden auf Fahrzeugen oder Schub- und Schleppverbänden bestimmte gefährliche Güter oder radioaktive Stoffe im Sinne von § 2 Abs. 1 Nr. 16 frei oder drohen freizuwerden oder besteht Explosionsgefahr, ist das folgende Schallsignal so lange zu geben, wie die Verkehrslage es erfordert:"
        },
        {
          "id": "b.text244",
          "text": "ein kurzer Ton, ein langer Ton; das Signal ist in jeder Minute mindestens 5mal hintereinander mit jeweils 2 Sekunden Zwischenpause zu geben; sofern entsprechende Einrichtungen an Bord sind, ist das Schallsignal gleichzeitig als Lichtsignal mit einem weißen Rundumlicht zu geben."
        },
        {
          "id": "b.text245",
          "text": "Im Bereich von Liege- und Umschlagsstellen ist das Signal auch von dem für den Betrieb der Umschlagsanlage Verantwortlichen zu geben."
        },
        {
          "id": "b.text246",
          "text": "Für die Ausrüstung zum Geben der Schallsignale von Umschlaganlagen gilt Anlage III der Kollisionsverhütungsregeln sinngemäß."
        },
        {
          "id": "b.text247",
          "text": "2.3"
        },
        {
          "id": "b.text248",
          "text": "Warnsignal auf dem Nord-Ostsee-Kanal \"ich vermindere meine Geschwindigkeit\""
        },
        {
          "id": "b.text249",
          "text": "Vermindert ein Fahrzeug seine Geschwindigkeit, während sich ein anderes Fahrzeug nähert, hat es rechtzeitig das Schallsignal zu geben:"
        },
        {
          "id": "b.text250",
          "text": "ein langer Ton, drei kurze Töne,"
        },
        {
          "id": "b.text251",
          "text": "ein langer Ton, drei kurze Töne."
        },
        {
          "id": "b.text252",
          "text": "2.4"
        },
        {
          "id": "b.text253",
          "text": "Warnsignal auf dem Nord-Ostsee-Kanal \"ich will anlegen\""
        },
        {
          "id": "b.text254",
          "text": "Will ein Fahrzeug in einem Hafen oder an einer Umschlagsstelle festmachen, während sich ein anderes Fahrzeug nähert, hat es rechtzeitig das Schallsignal zu geben:"
        },
        {
          "id": "b.text255",
          "text": "ein langer Ton, drei kurze Töne."
        },
        {
          "id": "b.text256",
          "text": "3."
        },
        {
          "id": "b.text257",
          "text": "Schallsignale bei verminderter Sicht"
        },
        {
          "id": "b.text258",
          "text": "3.1"
        },
        {
          "id": "b.text259",
          "text": "Auf dem Nord-Ostsee-Kanal haben in Fahrt befindliche Fahrzeuge mit Ausnahme der Fähren an Stellen, die durch Sichtzeichen B.1 (Anlage 1) gekennzeichnet sind, das Schallsignal zu geben:"
        },
        {
          "id": "b.text260",
          "text": "3.1.1"
        },
        {
          "id": "b.text261",
          "text": "westwärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text262",
          "text": "ein langer Ton;"
        },
        {
          "id": "b.text263",
          "text": "3.1.2"
        },
        {
          "id": "b.text264",
          "text": "ortswärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text265",
          "text": "zwei lange Töne."
        },
        {
          "id": "b.text266",
          "text": "Im übrigen ist das Schallsignal bei Erfordernis zu geben."
        },
        {
          "id": "b.text267",
          "text": "3.2"
        },
        {
          "id": "b.text268",
          "text": "Bugsierte Maschinenfahrzeuge in Fahrt"
        },
        {
          "id": "b.text269",
          "text": "Abweichend von Regel 35 Buchstabe a und b der Kollisionsverhütungsregeln ist das Schallsignal mindestens alle 2 Minuten zu geben:"
        },
        {
          "id": "b.text270",
          "text": "ein langer Ton, ein kurzer Ton, zwei lange Töne."
        },
        {
          "id": "b.text271",
          "text": "Die bugsierenden Schlepper dürfen das Schallsignal nach Regel 35 Buchstabe c der Kollisionsverhütungsregeln nicht geben."
        },
        {
          "id": "b.text272",
          "text": "3.3"
        },
        {
          "id": "b.text273",
          "text": "Fähren während der ganzen Fahrt"
        },
        {
          "id": "b.text274",
          "text": "3.3.1"
        },
        {
          "id": "b.text275",
          "text": "Nicht freifahrende Fähren:"
        },
        {
          "id": "b.text276",
          "text": "dauernde Einzelschläge der Glocke."
        },
        {
          "id": "b.text277",
          "text": "3.3.2"
        },
        {
          "id": "b.text278",
          "text": "Freifahrende Fähren:"
        },
        {
          "id": "b.text279",
          "text": "ein kurzer Ton, zwei lange Töne."
        },
        {
          "id": "b.text280",
          "text": "4."
        },
        {
          "id": "b.text281",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text282",
          "text": "5."
        },
        {
          "id": "b.text283",
          "text": "Ausweichsignal"
        },
        {
          "id": "b.text284",
          "text": "(§ 24 Abs. 3)"
        },
        {
          "id": "b.text285",
          "text": "5.1"
        },
        {
          "id": "b.text286",
          "text": "Hinweissignal \"Ich will links ausweichen\" sowie auf dem Nord-Ostsee-Kanal das Antwortsignal des Gegenkommers:"
        },
        {
          "id": "b.text287",
          "text": "ein langer Ton mit zwei Gruppen von zwei kurzen Tönen."
        },
        {
          "id": "b.text288",
          "text": "5.2"
        },
        {
          "id": "b.text289",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text290",
          "text": "6."
        },
        {
          "id": "b.text291",
          "text": "Anforderungssignal"
        },
        {
          "id": "b.text292",
          "text": "\"Brücke/Sperrtor/Schleuse öffnen\""
        },
        {
          "id": "b.text293",
          "text": "6.1"
        },
        {
          "id": "b.text294",
          "text": "Auf allen Seeschiffahrtsstraßen mit Ausnahme auf der Trave (bei Hubbrücken mit zwei Hubstufen \"öffnen bis zur 1. Hubstufe\"):"
        },
        {
          "id": "b.text295",
          "text": "zwei lange Töne."
        },
        {
          "id": "b.text296",
          "text": "6.2"
        },
        {
          "id": "b.text297",
          "text": "Auf der Trave"
        },
        {
          "id": "b.text298",
          "text": "6.2.1"
        },
        {
          "id": "b.text299",
          "text": "Seewärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text300",
          "text": "zwei lange Töne."
        },
        {
          "id": "b.text301",
          "text": "6.2.2"
        },
        {
          "id": "b.text302",
          "text": "Binnenwärts fahrende Fahrzeuge:"
        },
        {
          "id": "b.text303",
          "text": "zwei Gruppen von zwei langen Tönen."
        },
        {
          "id": "b.text304",
          "text": "6.3"
        },
        {
          "id": "b.text305",
          "text": "Bei Hubbrücken mit zwei Hubstufen \"öffnen bis zur letzten Hubstufe\":"
        },
        {
          "id": "b.text306",
          "text": "zwei lange Töne, ein kurzer Ton."
        },
        {
          "id": "b.text307",
          "text": "7."
        },
        {
          "id": "b.text308",
          "text": "Schleppersignale"
        },
        {
          "id": "b.text309",
          "text": "7.1"
        },
        {
          "id": "b.text310",
          "text": "Hinweissignal \"Ich möchte einen Schlepper\":"
        },
        {
          "id": "b.text311",
          "text": "ein kurzer Ton, ein langer Ton, ein kurzer Ton, ein langer Ton."
        },
        {
          "id": "b.text312",
          "text": "7.2"
        },
        {
          "id": "b.text313",
          "text": "Manövriersignale beim Schleppen"
        },
        {
          "id": "b.text314",
          "text": "7.2.1"
        },
        {
          "id": "b.text315",
          "text": "Hinweissignal \"Bugschlepper Schleppleine nehmen, anschleppen (antauen) oder loswerfen\":"
        },
        {
          "id": "b.text316",
          "text": "ein langer Ton, zwei kurze Töne, ein langer Ton."
        },
        {
          "id": "b.text317",
          "text": "7.2.2"
        },
        {
          "id": "b.text318",
          "text": "Hinweissignal \"Heckschlepper Schleppleine nehmen, anschleppen (antauen) oder loswerfen\":"
        },
        {
          "id": "b.text319",
          "text": "ein langer Ton, zwei kurze Töne, zwei lange Töne."
        },
        {
          "id": "b.text320",
          "text": "7.2.3"
        },
        {
          "id": "b.text321",
          "text": "Hinweissignal \"Bugschlepper nach Steuerbord schleppen (austauen)\":"
        },
        {
          "id": "b.text322",
          "text": "ein kurzer Ton."
        },
        {
          "id": "b.text323",
          "text": "7.2.4"
        },
        {
          "id": "b.text324",
          "text": "Hinweissignal \"Bugschlepper nach Backbord schleppen (austauen)\":"
        },
        {
          "id": "b.text325",
          "text": "zwei kurze Töne."
        },
        {
          "id": "b.text326",
          "text": "7.2.5"
        },
        {
          "id": "b.text327",
          "text": "Hinweissignal \"Heckschlepper zurückschleppen (zurücktauen)\":"
        },
        {
          "id": "b.text328",
          "text": "drei kurze Töne."
        },
        {
          "id": "b.text329",
          "text": "7.2.6"
        },
        {
          "id": "b.text330",
          "text": "Hinweissignal \"Heckschlepper nach Steuerbord schleppen (austauen)\":"
        },
        {
          "id": "b.text331",
          "text": "drei kurze Töne und nach einer Pause ein weiterer kurzer Ton."
        },
        {
          "id": "b.text332",
          "text": "7.2.7"
        },
        {
          "id": "b.text333",
          "text": "Hinweissignal \"Heckschlepper nach Backbord schleppen (austauen)\":"
        },
        {
          "id": "b.text334",
          "text": "drei kurze Töne und nach einer Pause zwei weitere kurze Töne."
        },
        {
          "id": "b.text335",
          "text": "7.2.8"
        },
        {
          "id": "b.text336",
          "text": "Hinweissignal \"Manöver verlangsamen oder einstellen\":"
        },
        {
          "id": "b.text337",
          "text": "ein langer Ton."
        },
        {
          "id": "b.text338",
          "text": "7.2.9"
        },
        {
          "id": "b.text339",
          "text": "Hinweissignal \"Gefahr\":"
        },
        {
          "id": "b.text340",
          "text": "fünf kurze Töne oder mehr."
        },
        {
          "id": "b.text341",
          "text": "8."
        },
        {
          "id": "b.text342",
          "text": "(aufgehoben)"
        },
        {
          "id": "b.text343",
          "text": "SeeSchStrO 1971 SeeSchStrO Anlage III Darstellung des Geltungsbereichs der Schiffahrtsstraßen-Ordnung"
        },
        {
          "id": "b.text344",
          "text": "(zu § 1 Abs. 5)"
        },
        {
          "id": "b.text345",
          "text": "(Inhalt: nicht darstellbare kartographische Karte; Fundstelle: BGBl. I 1998, 3264)"
        },
        {
          "id": "b.text346",
          "text": "SeeSchStrO 1971 SeeSchStrO Anlage IV Liste der berauschenden Mittel und Substanzen"
        },
        {
          "id": "b.text347",
          "text": "Mittel Substanz Heroin Morphin Morphin Morphin Kokain Benzoylecgonin Amfetamine Amfetamin Designer Amfetamine Methylendioxyamfetamin (MDA) Methylendioxyethylamfetamin (MDE) Methylendioxymetamfetamin (MDAE) Metamfetamin Metamfetamin"
        },
        {
          "id": "b.text348",
          "text": "Zum gesicherten Nachweis auf das Vorhandensein der in der Tabelle genannten Substanzen im Blut gelten die jeweils aktuellen Empfehlungen der Grenzwertkommission beim Bundesministerium für Digitales und Verkehr für den Bereich des Straßenverkehrs."
        },
        {
          "id": "b.text349",
          "text": "SeeSchStrO 1971 SeeSchStrO Anhang EV Auszug aus EinigVtr Anlage I Kapitel XI Sachgebiet D Abschnitt III"
        },
        {
          "id": "b.text350",
          "text": "(BGBl. II 1990, 889, 1108)"
        },
        {
          "id": "b.text351",
          "text": "Bundesrecht tritt in dem in Artikel 3 des Vertrages genannten Gebiet mit folgenden Maßgaben in Kraft: 1. - 7. ..."
        },
        {
          "id": "b.text352",
          "text": "8."
        },
        {
          "id": "b.text353",
          "text": "Seeschiffahrtsstraßen-Ordnung in der Fassung der Bekanntmachung vom 15. April 1987 (BGBl. I S. 1266), geändert durch Verordnung vom 8. August 1989 (BGBl. I S. 1583),"
        },
        {
          "id": "b.text354",
          "text": "mit folgender Maßgabe:"
        },
        {
          "id": "b.text355",
          "text": "Sämtliche bisherigen Seegewässer der Deutschen Demokratischen Republik gelten bis zu einer anderweitigen Regelung als Seeschiffahrtsstraßen im Sinne dieser Verordnung."
        },
        {
          "id": "b.text356",
          "text": "..."
        }
      ]
    }
  }
}
